import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { AuthState, AuthAction } from '../types';

const initialState: AuthState = {
  access_token: null,
  isLoggedIn: false,
  error: null,
  user: {
    first_name: '',
    last_name: '',
    email: '',
    pk: '',
    image_url: '',
    degree_bedore: '',
    degree_after: '',
  },
  employees: [],
  current_company: null,
  current_employee: null,
  licence: 'free',
  loading: false,
  loadingProfile: false,
  pagePermission: null,
  errorRegistration: null,
  successRegistration: null,
};

const authStart = (state: AuthState, _action: AuthAction): AuthState => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const authSuccess = (state: AuthState, action: AuthAction): AuthState => {
  return updateObject(state, {
    access_token: action.data.access,
    isLoggedIn: true,
    user: action.data.user,
    error: null,
    loading: false,
  });
};

const authFail = (state: AuthState, action: AuthAction): AuthState => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const authLogout = (state: AuthState, _action: AuthAction): AuthState => {
  return updateObject(state, undefined);
};

const userProfileStartLoading = (state: AuthState, _action: AuthAction): AuthState => {
  return {
    ...state,
    loadingProfile: true,
  };
};

const userProfileSuccess = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    loadingProfile: false,
    employees: action.data.employees,
    current_employee: action.data?.current_employee?.id,
    current_company: action.data?.current_employee?.company?.id,
    licence: action.data?.current_employee?.company?.licence_plan ?? 'free',
  };
};

const changeCurrentCompany = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    current_employee: action.id,
    current_company: action.company,
  };
};

const pagePermissionSucc = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    pagePermission: action.data,
  };
};

const registrationFail = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    errorRegistration: action.data,
  };
};

const registrationSucc = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    errorRegistration: null,
    successRegistration: action.data,
  };
};

const refreshConnectionSucc = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    access_token: action.access,
  };
};

const updateUserSuccessfull = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    user: { ...state.user, ...action.data },
  };
};

const changeLicence = (state: AuthState, action: AuthAction): AuthState => {
  return {
    ...state,
    licence: action.data,
  };
};

const reducer = (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.START_LOADING_USER_PROFILE:
      return userProfileStartLoading(state, action);
    case actionTypes.USER_PROFILE_LOADED:
      return userProfileSuccess(state, action);
    case actionTypes.CHANGE_CURRENT_COMPANY:
      return changeCurrentCompany(state, action);
    case actionTypes.REGISTRATION_FAIL:
      return registrationFail(state, action);
    case actionTypes.REGISTRATION_SUCC:
      return registrationSucc(state, action);
    case actionTypes.REGISTRATION_CONFIRM:
      return state;
    case actionTypes.REFRESH_CONNECTION_SUCCESS:
      return refreshConnectionSucc(state, action);
    case actionTypes.SET_PAGE_PERMISSION:
      return pagePermissionSucc(state, action);
    case actionTypes.UPDATE_USER_SUCCESSFULLY:
      return updateUserSuccessfull(state, action);
    case 'CHANGE_LICENCE':
      return changeLicence(state, action);
    default:
      return state;
  }
};

export default reducer;
